<template>
  <ul class="list-unstyled north-uni-links-menu menu-shadow text-medium">
    <li
      class="north-uni-link"
      @click="onNorthUniLinkClick(SOURCE.SIDEBAR_MENU, learnPageTabsIds.howNorthWorks)"
    >
      <router-link :to="getNorthUniPageLocation({ orgId, entity: learnPageTabsIds.howNorthWorks })"
        >How North works?
      </router-link>
    </li>
    <li
      class="north-uni-link"
      @click="onNorthUniLinkClick(SOURCE.SIDEBAR_MENU, learnPageTabsIds.goalTemplates)"
    >
      <router-link :to="getNorthUniPageLocation({ orgId, entity: learnPageTabsIds.goalTemplates })"
        >Goal templates
      </router-link>
    </li>
    <li class="nav-item nav-sublevel">
      <a
        href="https://thenorth.io/why-north/"
        target="_blank"
        class="d-flex align-items-center"
        rel="nofollow noopener noreferrer"
      >
        Why North?
        <i class="arrow-up-icon ml-2"></i>
      </a>
    </li>
    <li class="north-uni-link">
      <a
        href="https://feedback.thenorth.io/features"
        target="_blank"
        class="d-flex align-items-center"
        rel="nofollow noopener noreferrer"
      >
        Make a Suggestion
        <i class="arrow-up-icon ml-2"></i>
      </a>
    </li>
    <li @click="showKeyboardShortcuts">
      <a href="javascript:void(0)">Keyboard shortcuts</a>
    </li>
  </ul>
</template>

<script>
import { trackAnalyticsEvent } from '@/analytics'
import { EVENT_ACTION, EVENT_CATEGORY, SOURCE } from '@/constants/analytics'
import events from '@/constants/events'
import { learnPageTabsIds } from '@/constants/learn'
import EventBusMixin from '@/mixins/EventBusMixin'
import { getNorthUniPageLocation } from '@/utils/navigationConfigs'

/**
 * This is the menu that lists the links to North help materials i.e templates, kb shortcuts etc.
 */
export default {
  name: 'HelpLinksMenu',
  props: ['orgId'],
  mixins: [EventBusMixin],
  components: {},
  data() {
    return {
      learnPageTabsIds,
      SOURCE
    }
  },
  computed: {},
  methods: {
    onNorthUniLinkClick(source, entity) {
      trackAnalyticsEvent(EVENT_CATEGORY.NAVIGATION, EVENT_ACTION.VISIT_NORTH_UNI, {
        tab: entity,
        CTA: source
      })
    },
    getNorthUniPageLocation,
    showKeyboardShortcuts() {
      this.eventBusEmit(events.SHOW_KEYMAP_MODAL)
    }
  },
  mounted() {}
}
</script>

<style lang="scss" scoped>
@import '~@/styles/_styleConfigurations.scss';

.north-uni-links-menu {
  position: absolute;
  left: 14px;
  bottom: 120%;
  padding: 8px 0;
  border-radius: 6px;
  background-color: $documentColor;

  li a {
    padding: 0.25rem 1.5rem;
    white-space: nowrap;
    border-radius: 0;

    &:hover {
      background-color: $quinary;
    }
  }
}

.arrow-up-icon {
  @include dimension(12px, 11px);

  transform: rotate(135deg);
  margin-top: 2px;
  background-size: contain;
}

@include media-breakpoint-down(md) {
  .north-uni-links-menu {
    bottom: 50px;
    left: auto;
    right: 20px;
    width: auto;
  }
}
</style>
